import type {ReactElement} from 'react';
import {SocialPlatform} from '@Components/social-media/social-media.types';
import {getSocialIconURLByType} from '@Libraries/social-media';
import {PlatformMediaType} from '@Components/social-media/post.vo';
import styles from './social-thumbnail.module.scss';

interface SocialThumbnailProps {
  type: SocialPlatform;
  isActive?: boolean;
  shouldShowBorder?: boolean;
  customClasses?: string;
  platformMediaType?: PlatformMediaType;
  imgClassName?: string;
}

export function SocialThumbnail({
  type,
  isActive = false,
  shouldShowBorder = false,
  customClasses = '',
  platformMediaType = PlatformMediaType.POST,
  imgClassName = '',
}: SocialThumbnailProps): ReactElement<any> {
  const getClassByType = (): string => {
    switch (type) {
      case SocialPlatform.FACEBOOK:
      case SocialPlatform.FACEBOOK_PROFILE:
      case SocialPlatform.FACEBOOK_PAGE:
      case SocialPlatform.FACEBOOK_GROUP:
        return styles.facebook;
      case SocialPlatform.TWITTER:
        return styles.twitter;
      case SocialPlatform.LINKEDIN:
      case SocialPlatform.LINKEDIN_PAGE:
      case SocialPlatform.LINKEDIN_PROFILE:
        return styles.linkedin;
      case SocialPlatform.TIKTOK:
        return styles.tiktok;
      case SocialPlatform.YOUTUBE:
        return styles.youtube;
      case SocialPlatform.INSTAGRAM:
        return styles.instagram;
      case SocialPlatform.PINTEREST:
        return styles.pinterest;
      case SocialPlatform.GOOGLE_BUSINESS_PROFILE:
        return styles.googleBusinessProfile;
      case SocialPlatform.THREADS:
        return styles.threads;
      default:
        return '';
    }
  };

  return (
    <div className={`${styles.thumb} ${getClassByType()} ${isActive ? styles.isActive : ''} ${shouldShowBorder ? styles.borderStyles : ''} ${customClasses}`}>
      <img className={`${styles.img} ${imgClassName}`} src={getSocialIconURLByType(type, platformMediaType)} alt="" aria-hidden="true" />
    </div>
  );
}
